import React from 'react';
import { connect } from 'react-redux';

import ErrorNotFound from 'components/ErrorNotFound';
import { getStatusCode } from 'selectors/status';
import type { AppState } from 'stores';

type TravelContainerProps = {
  children: React.ReactNode;
  status: number;
};

const TravelContainer = (props: TravelContainerProps) => {
  const { children, status } = props;
  return (
    <div className="sl-travel-page-container">{status === 404 ? <ErrorNotFound /> : children}</div>
  );
};

export default connect((state: AppState) => ({
  status: getStatusCode(state),
}))(TravelContainer);
